import React from "react";
import Menubar from "./components/menuBar/menuBar";
import Home from "./screens/Home/Home";

function App() {
  return (
    <div style={{ height: "100%", width: "100%" }}>
      <Menubar />
      <Home />
    </div>
  );
}

export default App;
